module.exports = __webpack_public_path__ + "img/almost-done-en.0a39aba.png";